import React from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  Alert,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
} from "@mui/material";


const BulkStockInvestment = ({
  bulkAmount,
  setBulkAmount,
  valueStocks,
  previewData,
  generatePreview,
  orderMessage,
  severity,
  totalInvestment,
  remaining,
  handlePurchaseAll,
}) => {
  const perStock = valueStocks.length
    ? (bulkAmount / valueStocks.length).toFixed(2)
    : "0.00";

  return (
    <Box sx={{ mt: 6, p: 4, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", color: "#2d4890" }}>
        Distribute Investment Across All Value Stocks
      </Typography>

      <TextField
        label="Total Investment Amount (₹)"
        type="number"
        value={bulkAmount}
        onChange={(e) => setBulkAmount(e.target.value)}
        fullWidth
        sx={{ mb: 3 }}
      />

      <Paper
        sx={{
          p: 2,
          backgroundColor: "#ffffff",
          color: "#2d4890",
          border: "1px solid #ccc",
          borderRadius: 1,
        }}
      >
        <Typography>
          Investment will be distributed across <strong>{valueStocks.length}</strong> stocks,
          approximately <strong>₹{perStock}</strong> per stock
        </Typography>
      </Paper>

      <Button
        variant="contained"
        onClick={generatePreview}
        sx={{
          mt: 3,
          backgroundColor: "#2d4890",
          "&:hover": { backgroundColor: "#1b366b" },
          color: "#fff",
        }}
      >
        Generate Investment Preview
      </Button>

      {orderMessage && (
        <Alert severity={severity} sx={{ mt: 2 }}>
          {orderMessage}
        </Alert>
      )}

      {previewData.length > 0 && (
        <>
          <Table
            sx={{
              mt: 4,
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              borderRadius: 1,
            }}
            size="small"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#2d4890" }}>
                {["Symbol", "Current Price (₹)", "Quantity", "Investment (₹)", "Source"].map((head) => (
                  <TableCell key={head} sx={{ color: "#fff", fontWeight: "bold" }}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {previewData.map((stock, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ color: "#2d4890" }}>{stock.symbol}</TableCell>
                  <TableCell sx={{ color: "#2d4890" }}>₹{stock.current_price}</TableCell>
                  <TableCell sx={{ color: "#2d4890" }}>{stock.quantity}</TableCell>
                  <TableCell sx={{ color: "#2d4890" }}>₹{stock.investment.toFixed(2)}</TableCell>
                  <TableCell sx={{ color: "#2d4890" }}>{stock.price_source}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Divider sx={{ my: 4, bgcolor: "#bbb" }} />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
              color: "#2d4890",
            }}
          >
            <Typography variant="h6">
              Total Actual Investment: ₹{totalInvestment.toFixed(2)}
            </Typography>
            <Typography variant="h6">
              Remaining Amount: ₹{remaining.toFixed(2)}
            </Typography>
            <Typography variant="h6">
              Stocks Covered: {previewData.length}
            </Typography>
          </Box>

          <Button
            variant="contained"
            sx={{
              mt: 4,
              backgroundColor: "#2d4890",
              "&:hover": { backgroundColor: "#1b366b" },
              color: "#fff",
            }}
            onClick={handlePurchaseAll}
            fullWidth
          >
            Execute All Trades
          </Button>
        </>
      )}
    </Box>
  );
};

export default BulkStockInvestment;
